import { CharityDtoFlowEnum, GetMyCharityResponse } from '@expo/api-client';
import { PlanHomeFlow } from './planFlow/PlanHomeFlow';
import { RegularHomeFlow } from './regularFlow/RegularHomeFlow';
import { WateraidHomeFlow } from './wateraidFlow/WateraidHomeFlow';

export const RenderDynamicFlow = ({ chosenCharity }: { chosenCharity: GetMyCharityResponse }) => {
  switch (chosenCharity.flow) {
    case CharityDtoFlowEnum.Plan:
      return <PlanHomeFlow />;
    case CharityDtoFlowEnum.Wateraid:
      return <WateraidHomeFlow />;
    case CharityDtoFlowEnum.Regular:
    case CharityDtoFlowEnum.Ssm:
    case CharityDtoFlowEnum.Rfsu:
    case CharityDtoFlowEnum.Unhcr:
    default:
      return <RegularHomeFlow />;
  }
};
